import styled from "styled-components";
import { Link as BaseLink } from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  margin: 4.8rem auto;
  padding: 0 4.8rem;

  ${({ theme }) => theme.media.lg`
    margin: 2.4rem auto;
    padding: 0 2.4rem;
  `}

  @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
    margin: 2.4rem auto;
    padding: 0 2.4rem;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -2.4rem;

  @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
    margin: -1.2rem;
  }

  ${({ theme }) => theme.media.lg`
    margin: -1.2rem;
  `}
`;

export const Cell = styled.div`
  width: 20%;
  padding: 2.4rem;

  @media (max-width: 1999px) {
    width: 25%;
  }

  @media (max-width: 1550px) {
    width: calc(100% / 3);
  }

  @media (max-width: 1200px) {
    width: 50%;
  }

  @media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
    width: calc(100% / 3);
    padding: 1.2rem;
  }

  ${({ theme }) => theme.media.lg`
    padding: 1.2rem;
  `}

  ${({ theme }) => theme.media.md`
    width: 100%;
  `}
`;

export const Link = styled(BaseLink)`
  text-decoration: none;
`;

export const Disclaimer = styled.small`
  display: block;
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin-top: 4.8rem;
  text-align: center;
  color: ${({ theme }) => theme.styleGuide.colors.gray[700]};

  ${({ theme }) => theme.media.lg`
    margin-top: 2.4rem;
  `}
`;
